import { baseApi } from "../redux/baseAPI";

export const nurseApi = baseApi.injectEndpoints({
  tagTypes: [],
  endpoints: (builder) => ({
    updateNurseInfo: builder.mutation({
      query: (data) => ({
        url: `/nurses/update.json`,
        method: "POST",
        data,
      }),
    }),
  }),
});

export const { useUpdateNurseInfoMutation } = nurseApi;
